module.exports = __webpack_public_path__ + "static/media/35.82d93c2f.png";